/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";

import type { FC, SVGAttributes } from "react";

type Props = SVGAttributes<SVGElement>;

// FcWithoutChildren にしたいが props の定義が react に沿いきってないみたいでエラーが出るため FC を利用
export const MinusIcon: FC<Props> = (props) => {
  return (
    <svg viewBox="0 0 12 2" fill="none" {...props}>
      <path
        d="M11.8337 1.83317H0.166992V0.166504H11.8337V1.83317Z"
        fill="currentColor"
      />
    </svg>
  );
};
